import React from "react";
import EditTestQuestion from "./EditTestQuestion";
import { ITestQuestionId } from "../../TestQuestion.props";

const EditTestQuestionIndex: React.FC<ITestQuestionId> = ({ testQuestionId,setSelectedTestQuestionId }) => {
  return <EditTestQuestion testQuestionId={testQuestionId} setSelectedTestQuestionId={setSelectedTestQuestionId} />;
};

export default EditTestQuestionIndex;
